import { useState } from 'react'
import type { ChatOverview } from '@/types/teacher-chat'
import { ChatGroupHeader } from './ChatGroupHeader'
import { ChatItem } from './ChatItem'

interface ChatGroupProps {
  chat: ChatOverview
  isSelected: boolean
  defaultExpanded?: boolean
  onSelect: () => void
}

export function ChatGroup({ chat, isSelected, defaultExpanded = true, onSelect }: ChatGroupProps) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded)

  return (
    <div className="border-b border-gray-200">
      <ChatGroupHeader
        chat={chat}
        isExpanded={isExpanded}
        onToggle={() => setIsExpanded(v => !v)}
      />
      {isExpanded && (
        <ChatItem
          chat={chat}
          isSelected={isSelected}
          onSelect={onSelect}
        />
      )}
    </div>
  )
}
